import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";

export default function ProductsBoomlogic() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/logic.png"
          alt="Boomlogic"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">BoomLogic</div>
      </div>

      <div>
        <p className="fs-5 mt-3">IMAGINE – CREATE – FULFIL</p>
        <p className="fs-5 ">
          Imagining an environment with no barriers, no code, no risk and no
          financial constraint is no longer a dream… but a reality.{" "}
        </p>
        <p className="fs-5 ">
          In Logic, you can conceive, create and fulfil your organisation’s
          communication workflow needs in simple, manageable steps.
        </p>
        <p className="fs-5 ">
          {" "}
          Take advantage of the latest technology, utilise AI, and shape
          solutions to meet your exact requirements, delivering creativity,
          value and fulfilment.{" "}
        </p>
        <p className="fs-5 ">
          {" "}
          We provide a comprehensive range of services designed to meet the
          messaging and communication needs of any organisation.{" "}
        </p>
        <p className="fs-5 ">
          Simply consider what you need to improve a process, update legacy
          systems, engage with clients or customers, overcome a challenge, or
          communicate, escalate and manage more effectively, then come and talk
          to us.
        </p>
      </div>
      <div>
        <p className="fs-5 fw-bold ">Messaging</p>
        <p className="fs-5 ">
          Omni Messaging 2-way messaging, Inbound initiated, Autoreply
          Responding, Grouping, Notification{" "}
        </p>
        <p className="fs-5 fw-bold ">Workflow</p>
        <p className="fs-5 ">Surveys, Documentation, AI</p>{" "}
        <p className="fs-5 fw-bold ">Capability</p>
        <p className="fs-5 ">
          Counting, Filtering, Checking, Authorising, Lookups,
        </p>
      </div>
      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
